import { clientGet } from "@/api/client";
import { PaginationResponse } from "@/interfaces/api";
import { joinPaths } from "@/utils";
import { crud } from "../crud";
import { Composite } from "./models";

const COMPOSITE_PAGE_SIZE = 6;

const baseCompositeCrud = crud<Composite>("composite", "Composite");

export const compositeCrud = {
  ...baseCompositeCrud,
  getCompositesByTalent: (
    talentId: string,
    page: number,
    limit = COMPOSITE_PAGE_SIZE,
  ): Promise<PaginationResponse<Composite>> =>
    clientGet<PaginationResponse<Composite>>({
      path: joinPaths(baseCompositeCrud.path, "talent", talentId),
      params: { page, limit },
    }),
};
